package com.neurobs.ccabserver.subjectsessionview.components

import com.neurobs.react.ReactElementFactory

import scala.scalajs.js

object PropertyLabel {
  val pStyle = Seq[(String, js.Any)](("marginBottom", "0"), ("fontSize", "12px"))
  val spanStyle = Seq[(String, js.Any)](("color", "#555555"))

  def apply(name: String, value: String) = {
    ReactElementFactory.P(
      ReactElementFactory.Span(name + ": ")(spanStyle),
      value
    )(pStyle)
  }
}
